import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import TaxOption from '../../../components/TaxOption/TaxOption'
import { Tabs, Tab } from '@material-ui/core'
import {
  getTaxesDisplayNames,
  updateTaxesDisplayNames,
  saveUpdatedShop,
  updateDeliveryTaxRate,
} from '../../../actions/shop'
import { openSuccessMessage } from '../../../actions/message'
import { getSession } from '../../../utils/api'
import { getConsumerTypes } from '../../../api/consumer-type'
import { getCompanyFeatures } from '../../../actions/company'
import { updateShopInformation, getShopInformation } from '../../../actions/shopInformation'

const TaxOptionEditable = EditableHOCWrapper(TaxOption)

class TaxOptionContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Cannabis',
      taxDisplayNames: [],
      lastModifiedDisplayNames: null,
      nalTaxesOnly: false,
      consumerTypes: [],
    }
  }

  componentDidMount() {
    this.getTaxesDisplayNames()
    this.props.dispatch(getCompanyFeatures())
    this.fetchConsumerTypes()
  }

  fetchConsumerTypes = async () => {

    const consumerTypes = await getConsumerTypes() 
    if (consumerTypes) {
      this.setState({ consumerTypes })
    }
  }

  onSave = (data, afterOnSave) => {
    const { shop = {} } = this.props
    const { activeTab } = this.state
    if (activeTab === 'Cannabis') {
      this.props.updateShop(data).then((response) => afterOnSave(data))
    } else {
      this.props
        .updateShop({ ...shop, nonCannabisTaxes: data })
        .then((response) => afterOnSave(data))
    }
  }

  onSaveTaxAfterCityTax = (data, afterOnSave) => {
    const { shop = {} } = this.props
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}
    const changeFlagTaxAfterCityTax = shop.nalExciseAfterCityTax !== data.nalExciseAfterCityTax
    if (flagisNalTaxesOnly && changeFlagTaxAfterCityTax && data.nalExciseAfterCityTax) {
      data.taxTables.forEach((taxOption) => {
        taxOption.cityTax.activeExciseTax = false
      })
      this.props.updateShop(data).then((response) => afterOnSave(data))
      const { deliveryTaxRates = [] } = this.props.shopReducer
      deliveryTaxRates.forEach((deliveryTaxRate) => {
        if (deliveryTaxRate.useComplexTax) {
          deliveryTaxRate.taxTables.forEach((taxOption) => {
            taxOption.cityTax.activeExciseTax = false
          })
          this.props.dispatch(updateDeliveryTaxRate(deliveryTaxRate))
        }
      })
    } else {
      this.onSave(data, afterOnSave)
    }
  }

  updateShopSettings = (data, groupName) => {
    this.props.dispatch(updateShopInformation(data, groupName))
  }

  getShopSettings = (groupName) => {
    return this.props.dispatch(getShopInformation(groupName))
  }

  changeActiveTab = (e, value) => {
    this.setState({
      activeTab: value,
    })
  }

  getTaxesDisplayNames = () => {
    this.props.dispatch(getTaxesDisplayNames()).then((res) => {
      this.setState({ taxDisplayNames: res, lastModifiedDisplayNames: new Date().getTime() })
    })
  }

  updateTaxDisplayNames = (updatedTaxDisplayNames, afterSave) => {
    this.props.dispatch(updateTaxesDisplayNames(updatedTaxDisplayNames)).then((res) => {
      afterSave(res)
      console.log(res)
      const session = getSession()
      this.props.dispatch(
        saveUpdatedShop({ shop: res, session: { ...session, assignedShop: res } }),
      )
      this.props.dispatch(openSuccessMessage('Tax Display Names updated successfully'))
      this.getTaxesDisplayNames()
    })
  }

  render() {
    const { shop = {} } = this.props
    const { lastModified = null } = this.props.shopReducer
    const flagReducer = this.props.flagReducer
    const { isTaxPageEnabled = false } = flagReducer
    const {
      activeTab = 'Cannabis',
      taxDisplayNames = [],
      lastModifiedDisplayNames = null,
      consumerTypes,
    } = this.state
    const { nonCannabisTaxes = {} } = shop
    const { companyFeatures = {} } = this.props.companyReducer || {}
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}

    const { appTarget } = shop

    return (
      <Fragment>
        {appTarget === 'Distribution' ? (
          <TaxOptionEditable
            dataToEdit={shop || {}}
            onSave={this.onSaveTaxAfterCityTax}
            lastModified={lastModified}
            showExciseTax={true}
            isNonCannabis={activeTab === 'NonCannabis' ? true : false}
            taxDisplayNames={taxDisplayNames}
            getTaxesDisplayNames={this.getTaxesDisplayNames}
            lastModifiedDisplayNames={lastModifiedDisplayNames}
            updateTaxDisplayNames={this.updateTaxDisplayNames}
            companyFeatures={companyFeatures}
            isNalTaxesOnly={flagisNalTaxesOnly}
            updateShopSettings={this.updateShopSettings}
            getShopSettings={this.getShopSettings}
            consumerTypes={consumerTypes}
          />
        ) : (
          <Fragment>
            <Tabs
              value={this.state.activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.changeActiveTab}
              centered
              className="margin-bottom-small"
            >
              <Tab label="Cannabis Tax" value="Cannabis" />
              <Tab label="Non-cannabis Tax" value="NonCannabis" />
            </Tabs>
            {activeTab === 'Cannabis' ? (
              <TaxOptionEditable
                dataToEdit={shop || {}}
                onSave={this.onSaveTaxAfterCityTax}
                lastModified={lastModified}
                showExciseTax={true}
                isNonCannabis={activeTab === 'NonCannabis' ? true : false}
                taxDisplayNames={taxDisplayNames}
                getTaxesDisplayNames={this.getTaxesDisplayNames}
                lastModifiedDisplayNames={lastModifiedDisplayNames}
                updateTaxDisplayNames={this.updateTaxDisplayNames}
                companyFeatures={companyFeatures}
                isNalTaxesOnly={flagisNalTaxesOnly}
                updateShopSettings={this.updateShopSettings}
                getShopSettings={this.getShopSettings}
                consumerTypes={consumerTypes}
                isTaxPageEnabled={isTaxPageEnabled}
                routing={this.props.history}
              />
            ) : null}
            {activeTab === 'NonCannabis' ? (
              <TaxOptionEditable
                dataToEdit={nonCannabisTaxes || {}}
                onSave={this.onSave}
                lastModified={lastModified}
                showExciseTax={true}
                isNonCannabis={activeTab === 'NonCannabis' ? true : false}
                taxDisplayNames={taxDisplayNames}
                getTaxesDisplayNames={this.getTaxesDisplayNames}
                lastModifiedDisplayNames={lastModifiedDisplayNames}
                updateTaxDisplayNames={this.updateTaxDisplayNames}
                companyFeatures={companyFeatures}
                consumerTypes={consumerTypes}
                isTaxPageEnabled={isTaxPageEnabled}
                routing={this.props.history}
              />
            ) : null}
          </Fragment>
        )}
      </Fragment>
    )
  }
}

export default connect(({ shopReducer, authReducer, dispatch, companyReducer, flagReducer }) => ({
  shopReducer,
  authReducer,
  flagReducer,
  dispatch,
  companyReducer,
}))(ShopSettingsWithUpdate(ContainerWithTitleWrapper(TaxOptionContainer, 'Tax Options')))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/TaxOption.js